<div class="row">
    <div class="col-6 border-right border-success">
        <div class="row justify-content-center">
            <form [formGroup]="formulario.formGroup">
                <br><br>
                <fieldset>
                    <div class="row">
                        <div class="form-group col-4">
                            <label class="control-label small" for="codigoAcesso">Código de Acesso:</label>
                        </div>
                        <div class="form-group col-8">
                            <input [formControlName]="formulario.campos.codigoAcesso?.name" (blur)="onChangeWhitespaceRemover()" maxlength="6" size="6">
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-4">
                            <label class="control-label small" for="cpf">CPF:</label>
                        </div>
                        <div class="form-group col-8">
                            <input [formControlName]="formulario.campos.cpf?.name" bnMask="CPF" maxlength="14" size="20">
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-4">
                            <label class="control-label small" for="email">E-mail:</label>
                        </div>
                        <div class="form-group col-8">
                            <input [formControlName]="formulario.campos.email?.name" (blur)="onChangeWhitespaceRemover()" size="40">
                        </div>
                    </div>

                    <re-captcha *ngIf="this.showRecaptcha()"
                        [formControlName]="formulario.campos.myRecaptcha?.name"
                        site_key="{{loginCaptchaChaveCliente}}"
                        (captchaResponse)="handleCorrectCaptcha($event)">
                    </re-captcha>
                </fieldset>
                <app-botao-acessar  (clique)="realizarAcessoExterno()" [desabilitado]="!formulario.formGroup.valid"></app-botao-acessar>
            </form>
        </div>
    </div>
    <div class="col-6 border-left border-success">
        <div class="row justify-content-center">
            <app-acesso-gov-br [disabled]="!formulario.formGroup.enabled" [returnUrlParam]="returnUrlParam" [contarErro]="contarErro"></app-acesso-gov-br>
        </div>
    </div>
</div>
